import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { PATENT_DEMOS } from '../data/patentDemos';
import { generateDemoReportPdf } from '../utils/demoReportPdf';

export default function PatentDemoDownloadBar() {
  const { pathname } = useLocation();
  const parts = pathname.split('/').filter(Boolean);
  const slug = parts.length === 2 && parts[0] === 'patent-demos' ? parts[1] : null;
  const meta = slug ? PATENT_DEMOS[slug] : null;
  if (!meta) return null;
  return (
    <div className="fixed bottom-3 left-3 right-3 sm:left-auto sm:right-6 sm:bottom-6 z-[90] rounded-2xl border border-cyan-300/50 bg-[#071528]/95 shadow-2xl p-3 sm:w-[360px]">
      <div className="text-[10px] font-mono uppercase tracking-wider text-cyan-300 mb-2">P{meta.index} demo report</div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        <button type="button" onClick={() => generateDemoReportPdf(meta)} className="min-h-[48px] rounded-lg bg-cyan-500/20 border border-cyan-300/60 text-cyan-50 text-sm font-bold">Download Demo Report</button>
        <Link to={`/patent-demos/${slug}/brief`} className="min-h-[48px] rounded-lg bg-violet-500/20 border border-violet-300/50 text-violet-50 text-sm font-bold flex items-center justify-center text-center">Report Details</Link>
      </div>
    </div>
  );
}
